import type { ReactElement, SVGProps } from 'react'

import { useUnique } from '../Unique'
import { useFormattedText } from '../useFormattedText'

type Props = {
	alt: string | ReactElement
} & Omit<SVGProps<SVGSVGElement>, 'alt'>

export const Svg = ({ alt, children, ...props }: Props) => {
	const id = useUnique()
	const resolvedAlt = useFormattedText(alt)

	return (
		<svg {...props} aria-labelledby={id} role='img'>
			<title id={id}>{resolvedAlt}</title>
			{children}
		</svg>
	)
}
